window.customer = {
    base: {}
}